// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_st-5";
export var filledCircle = "_st-4";
export var historyEntry = "_st-3";
export var messageSideLeft = "_st-1";
export var messageSideRight = "_st-2";
export var orderTrackingCarouselWrapper = "_st-6";
export var orderTrackingInfoContainer = "_st-0";